import { AntDesign } from "@expo/vector-icons";
import { Pressable } from "react-native";
import { Colors } from "react-native-ui-lib";
import { useLocalSettingsProvider } from "../../../../../../utilities/local-settings";

export interface BarcodeComponentProps {
  onPress?: () => void;
}

export function BarcodeComponent({ onPress }: BarcodeComponentProps) {
  const { settings } = useLocalSettingsProvider();

  return (
    <Pressable onPress={onPress}>
      <AntDesign
        name="barcode"
        size={24}
        color={settings.scannerMode ? Colors.action : Colors.Text}
      />
    </Pressable>
  );
}
